import React from "react";
import PropTypes from "prop-types";
import ControlTemplate from "../BaseControls/ControlTemplate";
import DateInput from "../BaseControls/DateInput";
import {controlPropTypes} from "../formhelpers";
import maskFormats from "../BaseControls/InputMask/MaskConstants";

export default class Spinner extends React.Component {
    render() {
        const { descriptor } = this.props;

        const { granularity } = descriptor.config;

        let format = maskFormats.armus_time_second;
        let showCalendar = false;
        if(granularity === "SECOND") {
            format = maskFormats.armus_time_second;
            showCalendar = false;
        }
        else if(granularity === "MINUTE") {
            format = maskFormats.armus_time_minute;
            showCalendar = false;
        }
        else if(granularity === "HOUR") {
            format = maskFormats.armus_time_hour;
            showCalendar = false;
        }

        return (
            <ControlTemplate {...this.props} className="time-field" >
                <DateInput
                    {...this.props}
                    maskFormat={format}
                    showCalendar={showCalendar}
                />
            </ControlTemplate>
        );
    }
}

Spinner.propTypes = controlPropTypes({
    granularity: PropTypes.string
});



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/TimeField/spinner.js